import classnames from 'classnames';

import style from '../VaccinationTable.module.scss';
import { translate } from '@chaika/i18n/helper';

export function VaccinationHeader(): React.ReactElement<any> {
    return (
        <div className={style.heading}>
            <span className={classnames([style.item, style.vaccinationDate])}>{translate('introductionDate')}</span>
            <span className={classnames([style.item, style.birthDate])}>{translate('age')}</span>
            <span className={classnames([style.item, style.vaccine])}>{translate('drug')}</span>
            <span className={classnames([style.item, style.dose])}>{translate('dose')}</span>
            <span className={classnames([style.item, style.series])}>{translate('seriesTitle')}</span>
            <span className={classnames([style.item, style.expirationDate])}>{translate('expirationDate')}</span>
            <span className={classnames([style.item, style.stage])}>{translate('stage')}</span>
            <span className={classnames([style.item, style.deliveryMethod])}>{translate('area')}</span>
            <span className={classnames([style.item, style.reaction])}>{translate('reaction')}</span>
            <span className={classnames([style.item, style.clinic])}>{translate('clinic')}</span>
            <span className={classnames([style.item, style.entry])}>{translate('entryEhr')}</span>
            <span className={classnames([style.item, style.documents])}>{translate('documents')}</span>
            <span className={classnames([style.item, style.comment])}>{translate('comment')}</span>
        </div>
    );
}
